/** Bulk provision UI modes for the Canvas Access tab. */
export const CANVAS_ACCESS_BULK_MODE = {
  IDLE: 'IDLE',
  SAME_ROLE: 'SAME_ROLE',
  DIFFERENT_ROLES: 'DIFFERENT_ROLES',
};

/** Display labels for per-location Canvas provision status. */
export const CANVAS_ACCESS_STATUS = {
  LOCATION_NOT_READY: 'Location not ready',
  PROVISIONED: 'Provisioned',
  NOT_PROVISIONED: 'Not provisioned',
};

/** Tooltip copy for row-level Canvas role actions. */
export const CANVAS_ACCESS_ROW_TOOLTIP = {
  LOCATION_NOT_READY:
    'This location is not provisioned as a Canvas sub-account. Provision the location in Facility LMS first.',
  NO_ASSIGNABLE_ROLES:
    'No assignable Canvas admin roles are available for this location. Create a custom account role in Canvas, or contact the support team.',
  CHANGE_ROLE: 'Change Canvas role',
  ASSIGN_ROLE: 'Assign Canvas role',
  REMOVE_ACCESS: 'Remove access',
};

/** Draft-state key used when applying one role across all selected locations. */
export const CANVAS_ACCESS_BULK_SAME_ROLE_DRAFT_KEY = '__bulkSame';

/** Canvas Access tab eligibility from GET /provision-canvas. */
export const CANVAS_ACCESS_ELIGIBILITY_STATUS = {
  ELIGIBLE: 'ELIGIBLE',
  INELIGIBLE: 'INELIGIBLE',
};
